import { render, staticRenderFns } from "./QuestionMobility.vue?vue&type=template&id=617294e8&scoped=true"
import script from "./QuestionMobility.vue?vue&type=script&lang=js"
export * from "./QuestionMobility.vue?vue&type=script&lang=js"
import style0 from "./QuestionMobility.vue?vue&type=style&index=0&id=617294e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617294e8",
  null
  
)

export default component.exports